// ======================================================================
// File Name       : UsageSettingLiveConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const LIVE_FORMAT_NUM = {
  TWO_WAY: 0,
  ONE_WAY: 1,
};

export const LIVE_RECORDING_PERMISSION = [{ name: '許可しない', value: 0 }, { name: '許可する', value: 1 }];

export const TOTAL_AVAILABLE_TIME = {
  DURING: 0,
  HOUR: 1,
  MINUTE: 2,
};

export const LIVE_RECORDING_STATUS = [
 { name: '処理中', value: 0 },
 { name: '処理完了', value: 1 },
 { name: '処理エラー', value: 2 },
 { name: 'ダウンロード期限切れ', value: 3 },
];

export const LIVE_RECORDING_STATUS_COMPLETED = 1;
